import type { Nestable, Routable, Titled } from "@brookbush/types";

import { useRouter } from "next/compat/router";
import Link from "next/link";
import { useQueryState } from "next-usequerystate";

import Accordion from "~/components/Accordion";
import { constructQueryString } from "~/utils/helpers";

type CategoryItem = Routable & Titled & Nestable<CategoryItem>;

interface CategoryItemProps {
	category: CategoryItem;
	featuredCategory?: boolean;
	routeName: string;
}

const CategoryItem = ({
	category,
	featuredCategory = false,
	routeName,
}: CategoryItemProps) => {
	const { slugs } = (useRouter()?.query ?? {}) as {
		slugs?: string[];
	};

	const [accreditationFilter] = useQueryState("accreditation");

	const queryString = constructQueryString([
		{
			value: accreditationFilter,
			key: "accreditation",
		},
	]);

	const isCurrentCategory = slugs?.[0] === category.slug;

	return (
		<div className={`${routeName}-category`}>
			<Link
				scroll
				href={
					isCurrentCategory && slugs.length === 1
						? `/${routeName}${queryString}`
						: `/${routeName}/categories/${category.slug}${queryString}`
				}
			>
				<Accordion.Button
					className={featuredCategory && !isCurrentCategory ? "text-white" : ""}
					hasChildren={!!category.children?.length}
					isSelected={isCurrentCategory}
					isOpen={isCurrentCategory && slugs?.length === 2}
				>
					{category.title}
				</Accordion.Button>
			</Link>
			<Accordion.Panel
				isOpen={
					(isCurrentCategory &&
						category.children &&
						category.children?.length > 0) as boolean
				}
			>
				<div className="flex flex-col gap-1.5">
					{category.children?.map((subCategory) => (
						<Link
							scroll
							key={subCategory.slug}
							href={
								slugs?.[1] === subCategory.slug
									? `/${routeName}/categories/${category.slug}${queryString}`
									: `/${routeName}/categories/${category.slug}/${subCategory.slug}${queryString}`
							}
						>
							<Accordion.Button isSelected={slugs?.[1] === subCategory.slug}>
								{subCategory.title}
							</Accordion.Button>
						</Link>
					))}
				</div>
			</Accordion.Panel>
		</div>
	);
};

export default CategoryItem;
